<template>
    <div class="container_menu">
        <div class="poz_title_menu">
            <p class="number_box_services color_orange">
                {{ title }}
            </p>
        </div>
        <div class="box_text_menu box_text_menu_header">
            <p class="font_16_500_Montserrat_Medium color_gray menu-item-name">
                Блюдо
            </p>
            <div class="block_text_menu menu-item-meta">
                <p class="font_16_500_Montserrat_Medium color_gray white_50 text_align_right">
                    Объем
                </p>
                <p class="font_16_500_Montserrat_Medium color_gray white_50 text_align_right">
                    Цена
                </p>
            </div>
        </div>
        <div class="container_text_menu">
            <div
                v-for="(item, index) in items"
                :key="index"
                class="box_text_menu"
            >
                <p class="font_16_500_Montserrat_Medium menu-item-name">
                    {{ item.name }}
                </p>
                <div class="block_text_menu menu-item-meta">
                    <p class="font_16_500_Montserrat_Medium white_50 text_align_right">
                        {{ item.volume }}
                    </p>
                    <p class="font_16_500_Montserrat_Medium color_orange white_50 text_align_right">
                        {{ item.price }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        required: true,
    },
    items: {
        type: Array,
        required: true,
    },
});
</script>

<style scoped>
.container_menu {
    width: 100%;
    box-sizing: border-box;
}

.box_text_menu {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 72px 72px;
    gap: 16px;
    align-items: start;
}

.menu-item-name {
    min-width: 0;
    overflow-wrap: anywhere;
    line-height: 1.35;
}

.menu-item-meta {
    display: grid;
    grid-template-columns: 72px 72px;
    gap: 16px;
    align-items: start;
}

.menu-item-meta p {
    width: auto;
    min-width: 0;
}

.box_text_menu_header {
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

@media (max-width: 768px) {
    .container_menu {
        min-height: auto;
        padding: 20px 14px 14px;
        gap: 14px;
    }

    .box_text_menu {
        grid-template-columns: minmax(0, 1fr) 56px 56px;
        gap: 8px;
    }

    .menu-item-meta {
        grid-template-columns: 56px 56px;
        gap: 8px;
    }

    .menu-item-name,
    .menu-item-meta p {
        font-size: 0.8125rem;
        line-height: 1.2rem;
    }

    .box_text_menu_header {
        padding-bottom: 6px;
    }

    :deep(.poz_title_menu) {
        max-width: calc(100% - 28px);
        left: 14px;
        padding: 0 12px;
    }

    :deep(.number_box_services) {
        font-size: 0.95rem;
        line-height: 1rem;
        word-break: break-word;
    }
}
</style>
